import { useSelector } from "react-redux";
import { RootState } from "@store/store";

export const useCookieConsent = () => {
  const cookieState = useSelector((state: RootState) => state.cookieConsent);
  
  return {
    hasUserDecided: cookieState.hasUserDecided,
    cookiesAccepted: cookieState.cookiesAccepted,
    isConsentModalOpen: cookieState.isConsentModalOpen,
    consentTimestamp: cookieState.consentTimestamp,
  };
}; 